/** Notifee stub with common APIs used by reminder notifications. */
const notifee = {
  displayNotification: async () => undefined,
  createChannel: async () => 'default',
  onForegroundEvent: () => () => {},
  onBackgroundEvent: async () => {},
  cancelNotification: async () => {},
  cancelAllNotifications: async () => {},
  getTriggerNotificationIds: async () => [],
  createTriggerNotification: async () => undefined,
  requestPermission: async () => ({ authorizationStatus: 1 }),
  getNotificationSettings: async () => ({ authorizationStatus: 1 }),
};

export default notifee;
export const AndroidImportance = { DEFAULT: 3, HIGH: 4 };
export const EventType = { PRESS: 1, DISMISSED: 2, DELIVERED: 3 };
export const TriggerType = { TIMESTAMP: 0 };
